import './App.css';
import { Routes, Route } from 'react-router-dom'
import { Homepage } from './components/Homepage'
import HeatedGame from './components/HeatedGame';

const App = () => {
  return (
    <div className="App">
      <Routes>
        <Route path='/' element={<Homepage />} />
        <Route path='/playHeated' element={<HeatedGame />} />
      </Routes>
    </div>
  )
}


export default App;
